// /* eslint-disable prefer-promise-reject-errors */
// import config from 'src/config';
// import { postRequest, deleteRequest } from 'src/utils/RequestUtil';

// export const fileSearchAPI = function (data) {
//     const url = `${config.baseUrl}file/search`;
//     return postRequest({
//         url,
//         data,
//     });
// };

// // 🔴 Disable file upload
// export const fileCreateAPI = function (data) {
//     // alert('File upload is temporarily unavailable.');
//     // return Promise.reject('File upload is temporarily unavailable.');

//     // If you want to restore later, just uncomment below:
//     const fd = new FormData();
//     Object.keys(data).forEach((key) => {
//         fd.append(key, data[key]);
//     });
//     const url = `${config.baseUrl}file`;
//     return postRequest({
//         url,
//         data: fd,
//         headers: {
//             'Content-Type': 'multipart/form-data',
//         },
//     });
// };

// // 🔴 Disable file deletion
// export const fileDeleteAPI = function ({
//     fileId,
// }) {
//     // alert('File deletion is temporarily unavailable.');
//     // return Promise.reject('File deletion is temporarily unavailable.');

//     // If you want to restore later, just uncomment below:
//     const url = `${config.baseUrl}file/${fileId}`;
//     return deleteRequest({
//         url,
//     });
// };

// export default {
//     fileSearchAPI,
//     fileCreateAPI,
//     fileDeleteAPI,
// };
/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, deleteRequest } from 'src/utils/RequestUtil';

export const fileSearchAPI = function (data) {
    const url = `${config.baseUrl}file/search`;
    return postRequest({
        url,
        data,
    });
};

// ✅ Updated fileCreateAPI with robust FormData handling
export const fileCreateAPI = function (data) {
    const fd = new FormData();
    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            data[key].forEach((item) => fd.append(key, item));
        } else {
            fd.append(key, data[key]);
        }
    });
    const url = `${config.baseUrl}file`;
    return postRequest({
        url,
        data: fd,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const fileDeleteAPI = function ({ fileId }) {
    const url = `${config.baseUrl}file/${fileId}`;
    return deleteRequest({
        url,
    });
};

// ✅ New: fileDownloadAPI
export const fileDownloadAPI = async function (relativeUrl, fileName = 'downloaded-file') {
    try {

        // If S3 URL, convert to /uploads/<filename>
        if (relativeUrl.includes('amazonaws.com')) {
            const parts = relativeUrl.split('/');
            const filename = parts[parts.length - 1];
            relativeUrl = `/uploads/${filename}`;
        }
        const url = `${'https://loi-api.autonet.co.in'}${relativeUrl}`;
        const response = await fetch(url)

        if (!response.ok) throw new Error('File download failed');

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
        console.error('Download error:', err);
        alert('Download failed. Please try again.');
    }
};


export default {
    fileSearchAPI,
    fileCreateAPI,
    fileDeleteAPI,
    fileDownloadAPI,
};
